import globalDomains from '@/utils/global-domains';
import ApiCore from '@/api/index';

const SportsApi = ApiCore(globalDomains.SPORTS_AFREECATV);
export default SportsApi;
